module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/exclamation-circle-1495d322e2cd3f81b8d0c0b4a940d41a.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/exclamation-circle.svg
// module id = 6+om
// module chunks = 24